/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import CardDB from 'components/BiteDB/Cards/CardDB';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import Pagination from '@mui/material/Pagination';

interface TeamKeys {
  name: string;
  id: string;
}
interface DashboardProps {
  databases: any[];
  isLoading: boolean;
  runScreeningDatabase: (id: string) => void;
  onRefresh: () => void;
}

const Databases: React.FC<DashboardProps> = ({
  databases,
  isLoading,
  onRefresh,
  runScreeningDatabase
}) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const [ isDropdownOpen, setIsDropdownOpen ] = useState(false);
  const [ selectedOptsType, setSelectedOptsType ] = useState<string[]>([]);
  const [ selectedItems, setSelectedItems ] = useState<any[]>([]);
  const [ nrPeopleAndCompanies, setNrPeopleAndCompanies ] = useState(0);
  const [ nrProducts, setNrProducts ] = useState(0);
  const [ tab, setTab ] = useState<string>('All');
  const [ selectedTab, setSelectedTab ] = useState<string>('All');
  const [ searchTerm, setSearchTerm ] = useState<string>('');
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ totalPages, setTotalPages ] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    if (databases.length > 0) {
      setCurrentItems(databases.slice(indexOfFirstItem, indexOfLastItem));
      setTotalPages(Math.ceil(databases.length / itemsPerPage));
    } else {
      setTotalPages(1);
      setCurrentPage(1);
    }
  }, [ currentPage, itemsPerPage, databases ]);

  const handleTabSwitch = (type: string) => {
    switch (type) {
    case 'All':
      setTab('All');
      setSelectedTab('All');
      break;
    case 'Products':
      setTab('Products');
      setSelectedTab('products');
      break;
    case 'People & Co.':
      setTab('People & Co.');
      setSelectedTab('people & companies');
      break;
    default:
      setTab('All');
      setSelectedTab('All');
    }
  };

  const getParagraphText = (database: any) => {
    let paragraphText = 'Never updated';

    if (database.last_screen_timestamp) {
      const lastScreenedDate = new Date(database.last_screen_timestamp);
      const today = new Date();
      const diffTime = Math.abs(today.getTime() - lastScreenedDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      paragraphText = `Updated ${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    }
    return paragraphText;
  };

  const handlePageChange = (e: ChangeEvent<unknown>, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentItems(databases.slice(indexOfFirstItem, indexOfLastItem));
  };

  return (
    <div className='team-content-container' style={{ paddingTop: '24px' }}>
      <div className='people-col'>
        <div className='team-content-header'>
          <div className='team-content-search'>
            <div className='card-db-header'>
              <div className='card-db-icon'>{<svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M4 18V6' stroke='var(--Primary-400, #4895ef)' strokeWidth='1.5' strokeLinecap='round'/>
                <path d='M20 6V18' stroke='var(--Primary-400, #4895ef)' strokeWidth='1.5' strokeLinecap='round'/>
                <path d='M12 10C16.4183 10 20 8.20914 20 6C20 3.79086 16.4183 2 12 2C7.58172 2 4 3.79086 4 6C4 8.20914 7.58172 10 12 10Z' stroke='var(--Primary-400, #4895ef)' strokeWidth='1.5'/>
                <path d='M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12' stroke='var(--Primary-400, #4895ef)' strokeWidth='1.5'/>
                <path d='M20 18C20 20.2091 16.4183 22 12 22C7.58172 22 4 20.2091 4 18' stroke='var(--Primary-400, #4895ef)' strokeWidth='1.5'/>
              </svg>}</div>
              <div className='card-db-title'>{'Your Databases'}</div>
            </div>
          </div>
          {/* <div className='create-new-team-btn' onClick={() => {
            return;
          }}>
            <div className='create-new-team-btn-text'>
                + Create Database
            </div>
          </div> */}
        </div>
        <div className='team-content-header'>
          <div className='team-content-search'>
            <span className='card-db-meta-span'> {'Manage your databases .i.e. suppliers, partners, and other business relationships.'}</span>
          </div>
        </div>
      </div>
      <div className='team-content-header'>
        <div className='team-content-search'>
          <div className='screening-input-field-container'>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
              <path d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
            <input
              placeholder='Search Databases'
              id='primary'
              type='text'
              className='screening-input-field-content'
              name='primary'
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  // Additional action on Enter if needed
                }
              }}
            />
          </div>
        </div>
        <div className='home-search-frame-input-action-cont-sec' style={{ borderRadius: 'var(--radius-full, 9999px)', border: '1.5px solid var(--Primary-400, #4895ef)' }}>
          <div onClick={() => handleTabSwitch('All')} className={`home-search-frame-input-action-cont-btn ${tab === 'All' ? 'selected' : ''}`}>All</div>
          <div onClick={() => handleTabSwitch('Products')} className={`home-search-frame-input-action-cont-btn ${tab === 'Products' ? 'selected' : ''}`}>Products</div>
          <div onClick={() => handleTabSwitch('People & Co.')} className={`home-search-frame-input-action-cont-btn ${tab === 'People & Co.' ? 'selected' : ''}`}>Entities</div>
        </div>
      </div>
      <div className='audit-dashboard-cards-frame-box' style={{ width: '100%' }}>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress color='primary' />
          </div>
        ) : databases.length === 0 ? (
          <div className='audit-dashboard-cards-no-ticket'>
            No Databases Found
          </div>
        ) : (
          <div className='audit-dashboard-cards-frame' style={{ width: '100%' }}>
            {
              currentItems.filter((item: { type: string }) => selectedTab === 'All' || item.type === selectedTab).map((database: any, index: number) => {
                return (
                  <CardDB
                    key={index}
                    id={database.id}
                    svgIcon={ database.type === 'products' ? <Inventory2OutlinedIcon sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }} /> : <PeopleAltOutlinedIcon sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }} />}
                    title={database.name}
                    paragraph={getParagraphText(database)}
                    total={(
                      (parseInt(database.nr_people_and_companies, 10) || 0) +
        (parseInt(database.nr_products, 10) || 0) +
        (parseInt(database.nr_tariffs, 10) || 0)
                    ).toString()}
                    category={database.type}
                    // runScreen={() => runScreeningDatabase(database.id)}
                  />
                );
              })
            }
          </div>

        )}
      </div>
      {databases.length > 9 && <div className='hb-pagination' style={{ width: '100%' }}>
        <Pagination
          onChange={handlePageChange}
          size='large'
          count={totalPages}
          shape='rounded'
          variant='text'
          page={currentPage}
        />
      </div>}
    </div>
  );
};

export default Databases;


